import App from '../App'


export default[
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/home',
            component: resolve => require(['../page/home/home.vue'], resolve),
            meta:{requireAuth:true},
            children:[
                {
                    path: '/',
                    component: resolve => require(['../page/home/bence/bence.vue'], resolve),
                    meta:{requireAuth:true},
                },{
                    path: 'moban1',
                    component: resolve => require(['../page/home/moban1/moban1.vue'], resolve),
                    meta:{requireAuth:true},
                },{
                    path: 'moban2',
                    component: resolve => require(['../page/home/moban2/moban2.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'applyLoan',//申请借款
                    component: resolve => require(['../page/home/applyLoan/applyLoan.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'recordInformation',//个人信息和企业信息下一步 录信息
                    component: resolve => require(['../page/home/recordInformation/recordInformation.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'corporateAndPersonInfo',//申请借款下一步  个人信息和企业信息
                    component: resolve => require(['../page/home/corporateAndPersonInfo/corporateAndPersonInfo.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'signingManage',//发标管理
                    component: resolve => require(['../page/home/signingManage/signingManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'openBid',//开标
                    component: resolve => require(['../page/home/openBid/openBid.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'inBid',//投标中
                    component: resolve => require(['../page/home/inBid/inBid.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'repaymentManage',//还款管理
                    component: resolve => require(['../page/home/repaymentManage/repaymentManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'fullMark', //满标
                    component: resolve => require(['../page/home/fullMark/fullMark.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'cashBack',//回款中
                    component: resolve => require(['../page/home/cashBack/cashBack.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'flowed',//已流标
                    component: resolve => require(['../page/home/flowed/flowed.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'backgroundBid',//后台投标
                    component: resolve => require(['../page/home/backgroundBid/backgroundBid.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'repaymentCompleted',//还款已完成
                    component: resolve => require(['../page/home/repaymentCompleted/repaymentCompleted.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'investorManage',//投资者管理
                    component: resolve => require(['../page/home/investorManage/investorManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'borrowerManage',//借款者管理
                    component: resolve => require(['../page/home/borrowerManage/borrowerManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'letterInquiry',//即信查询
                    component: resolve => require(['../page/home/letterInquiry/letterInquiry.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'offerList',//优惠礼包列表
                    component: resolve => require(['../page/home/offerList/offerList.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'flowManage',//流水管理
                    component: resolve => require(['../page/home/flowManage/flowManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'bannerManage',//banner管理
                    component: resolve => require(['../page/home/bannerManage/bannerManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'redEnvelopeTypeManage',//红包类型管理
                    component: resolve => require(['../page/home/redEnvelopeTypeManage/redEnvelopeTypeManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'repaymentSameSayJiangxi',//当天还款（江西银行）
                    component: resolve => require(['../page/home/repaymentSameSayJiangxi/repaymentSameSayJiangxi.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'collectionSms',//催收短信发送
                    component: resolve => require(['../page/home/collectionSms/collectionSms.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'repaymentPlanInquiry',//还款计划查询
                    component: resolve => require(['../page/home/repaymentPlanInquiry/repaymentPlanInquiry.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'repaymentSameSay',//当天还款
                    component: resolve => require(['../page/home/repaymentSameSay/repaymentSameSay.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'rechargeManage',//充值管理
                    component: resolve => require(['../page/home/rechargeManage/rechargeManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'withdrawManage',//提现管理
                    component: resolve => require(['../page/home/withdrawManage/withdrawManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'userDetail',//充值提现管理详情
                    component: resolve => require(['../page/home/userDetail/userDetail.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'userMangeDetail',//用户管理详情
                    component: resolve => require(['../page/home/userMangeDetail/userMangeDetail.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'targetDetail',//标的详细信息
                    component: resolve => require(['../page/home/targetDetail/targetDetail.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'openBidDetail',//开标详情
                    component: resolve => require(['../page/home/openBidDetail/openBidDetail.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'couponManage',//优惠券管理
                    component: resolve => require(['../page/home/couponManage/couponManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'operationStatistics',//运营统计
                    component: resolve => require(['../page/home/operationStatistics/operationStatistics.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'fastBankManage',//快捷银行管理
                    component: resolve => require(['../page/home/fastBankManage/fastBankManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'verified',//实名认证
                    component: resolve => require(['../page/home/verified/verified.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'transactionLog',//交易日志
                    component: resolve => require(['../page/home/transactionLog/transactionLog.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'invitationCashbackConfirmation',//邀请返现确认
                    component: resolve => require(['../page/home/invitationCashbackConfirmation/invitationCashbackConfirmation.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'rateRules',//费率规则
                    component: resolve => require(['../page/home/rateRules/rateRules.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'separateSettlement',//分润结算
                    component: resolve => require(['../page/home/separateSettlement/separateSettlement.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'invitationAudit',//邀请返现审核
                    component: resolve => require(['../page/home/invitationAudit/invitationAudit.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'preliminaryExamination',//标的初审
                    component: resolve => require(['../page/home/preliminaryExamination/preliminaryExamination.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'subjectReview',//标的复审
                    component: resolve => require(['../page/home/subjectReview/subjectReview.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'financialSettlement',//财务结算
                    component: resolve => require(['../page/home/financialSettlement/financialSettlement.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'industryInformation',//行业资讯
                    component: resolve => require(['../page/home/industryInformation/industryInformation.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'industryInformationCreate',//行业资讯新建
                    component: resolve => require(['../page/home/industryInformationCreate'], resolve),
                    meta:{requireAuth:true},
                },
                
                {
                    path: 'messageManage',//留言管理
                    component: resolve => require(['../page/home/messageManage/messageManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'announcementManage',//公告管理
                    component: resolve => require(['../page/home/announcementManage/announcementManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'announcementManageCreate',//公告管理新建 修改
                    component: resolve => require(['../page/home/announcementManageCreate'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'smsMarket',//短信营销
                    component: resolve => require(['../page/home/smsMarket/smsMarket.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'overdueMarket',//逾期营销
                    component: resolve => require(['../page/home/overdueMarket/overdueMarket.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'departmentManage',//部门管理
                    component: resolve => require(['../page/home/departmentManage/departmentManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'roleManage',//角色管理
                    component: resolve => require(['../page/home/roleManage/roleManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'staffManage',//员工管理
                    component: resolve => require(['../page/home/staffManage/staffManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'dayTask',//当日任务
                    component: resolve => require(['../page/home/dayTask/dayTask.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'menuManage',//菜单管理
                    component: resolve => require(['../page/home/menuManage/menuManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'authManage',//权限管理
                    component: resolve => require(['../page/home/authManage/authManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'operationLog',//操作日志
                    component: resolve => require(['../page/home/operationLog/operationLog.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'businessRecharge',//企业充值
                    component: resolve => require(['../page/home/businessRecharge/businessRecharge.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'corporateCashWithdrawal',//企业提现
                    component: resolve => require(['../page/home/corporateCashWithdrawal/corporateCashWithdrawal.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'managedInterface',//托管接口
                    component: resolve => require(['../page/home/managedInterface/managedInterface.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'coinDepository',//即信存管
                    component: resolve => require(['../page/home/coinDepository/coinDepository.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'numSet',//数值设置
                    component: resolve => require(['../page/home/numSet/numSet.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'posInterface',//POS接口
                    component: resolve => require(['../page/home/posInterface/posInterface.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'permission',//权限
                    component: resolve => require(['../page/home/permission/permission.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'roleList',//角色列表
                    component: resolve => require(['../page/home/roleList/roleList.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'initialReview',//初审更新审批
                    component: resolve => require(['../page/home/initialReview/initialReview.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'investList',//投资列表
                    component: resolve => require(['../page/home/investList/investList.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'collectioning',//采集中
                    component: resolve => require(['../page/home/collectioning/collectioning.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'overdue',//逾期
                    component: resolve => require(['../page/home/overdue/overdue.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'privilegeTreeManage',//权限树管理
                    component: resolve => require(['../page/home/privilegeTreeManage/privilegeTreeManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'excelExport',//excel管理
                    component: resolve => require(['../page/home/excelExport/excelExport.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'excelExportDYD',//excel DYD管理
                    component: resolve => require(['../page/home/excelExportDYD/excelExportDYD.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'newRegistrations',//新增注册人数
                    component: resolve => require(['../page/home/newRegistrations/newRegistrations.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'repaymentToday',//当天还款列表
                    component: resolve => require(['../page/home/repaymentToday/repaymentToday.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'feedback',//当天意见反馈列表
                    component: resolve => require(['../page/home/feedback/feedback.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'couponTemplteManage',//优惠券模版管理
                    component: resolve => require(['../page/home/couponTemplteManage/couponTemplteManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'issueCoupons',//发放优惠券
                    component: resolve => require(['../page/home/issueCoupons/issueCoupons.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'couponPackageManage',//礼包管理
                    component: resolve => require(['../page/home/couponPackageManage/couponPackageManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'userStatueQuery',//运营管理 用户状态管理
                    component: resolve => require(['../page/home/userStatueQuery/userStatueQuery.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'anXuanTou',//运营管理 安选投列表
                    component: resolve => require(['../page/home/anXuanTou/anXuanTou.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'anXuanTouCreate',//运营管理 安选投列表创建
                    component: resolve => require(['../page/home/anXuanTouCreate/anXuanTouCreate.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'pointManage',//商城 积分管理 
                    component: resolve => require(['../page/home/pointManage/pointManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'pointDetail',//商城 积分明细
                    component: resolve => require(['../page/home/pointDetail/pointDetail.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'commodityManage',//商品管理
                    component: resolve => require(['../page/home/commodityManage/commodityManage.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'commodityManageCreate',//商品管理新建
                    component: resolve => require(['../page/home/commodityManageCreate/commodityManageCreate.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'redemptionRecord',//商品兑换记录
                    component: resolve => require(['../page/home/redemptionRecord/redemptionRecord.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'creditQuery',//征信查询
                    component: resolve => require(['../page/home/creditQuery/creditQuery.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'anrongcreditQuery',//征信查询
                    component: resolve => require(['../page/home/anrongcreditQuery/anrongcreditQuery.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'channelMaintenance',//渠道管理
                    component: resolve => require(['../page/home/channelMaintenance/channelMaintenance.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'flowQuery',//流水查询
                    component: resolve => require(['../page/home/flowQuery/flowQuery.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'moneyFlowingWater',//资金流水
                    component: resolve => require(['../page/home/moneyFlowingWater/moneyFlowingWater.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'registrationCenter',//注册中心
                    component: resolve => require(['../page/home/registrationCenter/registrationCenter.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'serviceMonitoring',//服务监控
                    component: resolve => require(['../page/home/serviceMonitoring/serviceMonitoring.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'serviceDeployment',//服务部署
                    component: resolve => require(['../page/home/serviceDeployment/serviceDeployment.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'eventsList',//活动列表
                    component: resolve => require(['../page/home/eventsList/eventsList.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'actPool',//奖品池
                    component: resolve => require(['../page/home/actPool/actPool.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'actRecord',//活动记录
                    component: resolve => require(['../page/home/actRecord/actRecord.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'informationCheck',//信息校验
                    component: resolve => require(['../page/home/informationCheck'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'specialAttentionList',//特别关注名单
                    component: resolve => require(['../page/home/specialAttentionList'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'antiFraud',//反欺诈
                    component: resolve => require(['../page/home/antiFraud'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'baofu',//宝付
                    component: resolve => require(['../page/home/baofu/baofu.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'virtualLoan',//虚标
                    component: resolve => require(['../page/home/virtualLoan/virtualLoan.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'virtualLoanCreate',//虚标创建
                    component: resolve => require(['../page/home/virtualLoanCreate/virtualLoanCreate.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'innerMail',//站内信
                    component: resolve => require(['../page/home/innerMail/innerMail.vue'], resolve),
                    meta:{requireAuth:true},
                },
                {
                    path: 'userSms',//短信管理
                    component: resolve => require(['../page/home/userSms/userSms.vue'], resolve),
                    meta:{requireAuth:true},
                },
                
                



                

                
                
                
                
                
                
                
                
                
                
                
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../page/login/login.vue'], resolve),
            meta:{requireAuth:false},
        },
    
]


// WEBPACK FOOTER //
// ./src/router/router.js